import { StylishNewButton } from '../../DesignSystems/New/StylishNewButton';
import React from 'react';
import { useSitrepSectionWizardContext } from './SitrepSectionWizardContext';
import { SITREP_SECTION_STEPS } from './types';

/**
 * This component renders three possible buttons:
 *
 * - Back: Goes to the previous step (if not on the first step)
 * - Next: Goes to the next step (if not on the last step)
 * - Create: Finalizes the section (if on the last step)
 */
const SitrepSectionWizardFooter = ({
  setIsEditingSitrepSections,
}: {
  setIsEditingSitrepSections: (isEditing: boolean) => void;
}) => {
  const {
    activeStep,
    sectionName,
    sectionType,
    handleNext,
    handleBack,
    handleCreateSectionTemplate,
  } = useSitrepSectionWizardContext();

  // Manual / Automated: create from step 1 once a name is set.
  // AI: create from step 1 when a default/template name is chosen; otherwise Next.
  const canCreateFromStepOne = activeStep.id === 1 && !!sectionName?.trim();

  const showCreate =
    activeStep.id === SITREP_SECTION_STEPS.length || canCreateFromStepOne;

  return (
    <div className="sidebar-footer d-flex justify-content-end align-self-end position-fixed gap-3 px-3">
      {activeStep.id > 1 ? (
        <StylishNewButton
          className="button--secondary color-white"
          onClick={handleBack}
        >
          Back
        </StylishNewButton>
      ) : (
        <StylishNewButton
          className="button--secondary color-white"
          onClick={() => setIsEditingSitrepSections(false)}
        >
          Cancel
        </StylishNewButton>
      )}
      {showCreate ? (
        <StylishNewButton
          className="button--primary"
          onClick={handleCreateSectionTemplate}
        >
          Create
        </StylishNewButton>
      ) : (
        <StylishNewButton
          className="button--primary"
          onClick={
            sectionType === 'manual' || sectionType === 'automated'
              ? handleCreateSectionTemplate
              : handleNext
          }
          disabled={
            (sectionType === 'manual' || sectionType === 'automated') &&
            !sectionName?.trim()
          }
        >
          {sectionType === 'manual' || sectionType === 'automated'
            ? 'Create'
            : 'Next'}
        </StylishNewButton>
      )}
    </div>
  );
};

export default SitrepSectionWizardFooter;
